module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_05.eece1e28.jpg";